import {ApplicationRef, Component, ComponentFactoryResolver, InjectionToken, Injector} from "@angular/core";
import {SidebarRightConfig, SidebarRightService} from "@webmate-web-core/shared/components/sidebarright/sidebarright.service";
import {ComponentPortal, DomPortalOutlet, PortalInjector} from "@angular/cdk/portal";
import {ComponentType} from "@angular/cdk/overlay";

export const SIDEBARRIGHT_DATA = new InjectionToken<any>('SIDEBARRIGHT_DATA');

@Component({
    selector: 'wm-sidebar-right',
    templateUrl: './sidebarright.component.html',
    styleUrls: ['./sidebarright.component.less']
})
export class SidebarRightComponent {
    private sidebarHost: DomPortalOutlet;

    private component: ComponentType<any>;

    private sidebarPortal: ComponentPortal<any>;

    constructor(private componentFactoryResolver: ComponentFactoryResolver,
                private injector: Injector,
                private appRef: ApplicationRef,
                private sidebarService: SidebarRightService) {

    }

    closeSidebar(event: MouseEvent) {
        this.sidebarService.closeSidebar();
    }

    ngAfterViewInit() {
        this.sidebarService.sidebarComponent$().subscribe(next => {
            if (!!next) {
                this.component = next[0];
                this.renderSidebarComponent(next[0], next[1]);
                this.isOpened = true;
            } else {
                this.isOpened = false;
                this.disposeSidebarComponent();
            }
        });
    }

    disposeSidebarComponent() {
        if (this.sidebarHost) {
            this.sidebarHost.detach();
        }
        const elem = document.querySelector('#wm-sidebarright-container');
        if (elem.firstChild) {
            elem.removeChild(elem.firstChild);
        }
    }

    renderSidebarComponent(comp, data) {
        const injectorTokens = { provide: SIDEBARRIGHT_DATA,
            useValue: data
        };

        const injector = Injector.create({ providers: [injectorTokens] });

        const portal = new ComponentPortal<any>(comp, null, injector);
        this.sidebarHost = this.makeSidebarOutlet();
        this.sidebarHost.attachComponentPortal(portal);
        this.sidebarPortal = portal;
    }

    makeSidebarOutlet(): DomPortalOutlet {
        return new DomPortalOutlet(document.querySelector('#wm-sidebarright-container'),
            this.componentFactoryResolver, this.appRef, this.injector)
    }

    isOpened: boolean = false;
}
